import { FC } from "react";

import HomeContainer from "containers/Home";

const Home: FC = () => {
  return <HomeContainer />;
};

export default Home;
